import { render, staticRenderFns } from "./filter-renderer-farben.vue?vue&type=template&id=23ef8cd4"
import script from "./filter-renderer-farben.vue?vue&type=script&lang=js"
export * from "./filter-renderer-farben.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports